import { useEffect, useRef, useState } from 'react';

export const useTextLoading = (texts: string[]) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const progressRef = useRef<HTMLDivElement | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (texts.length === 0) return;

    let startTime: number;
    const duration = 3000;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const percent = Math.min((elapsed / duration) * 100, 100);
      setProgress(percent);

      if (elapsed < duration) {
        requestAnimationFrame(animate);
      }
    };

    const cycleText = () => {
      setCurrentTextIndex((prev) =>
        prev === texts.length - 1 ? 0 : prev + 1
      );
      setProgress(0);
      startTime = 0;
      requestAnimationFrame(animate);
    };

    // Primeira animação
    requestAnimationFrame(animate);
    intervalRef.current = setInterval(cycleText, duration);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [texts]);

  return {
    currentTextIndex,
    progress,
    progressRef,
  };
};
